module.exports = __webpack_public_path__ + "static/media/lada.acb8002e.svg";